import React, { useEffect } from 'react';
import { Alert, Box, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Component, useMenuContext } from '../../../context/menuContext';

import {
  POSReconciliation,
  SalesTaxReport,
  Overview,
  SalesReport,
  DepositReconciliation,
} from './ReportsSubItems';
import { useStyles } from './Reports.styles';
import { Loading } from '../../layout/Loading';
import { Error } from '../../layout/Error';
import { NoRestaurants } from '../../layout/NoRestaurants';
import { getSettings } from '../../../redux/ducks/RestaurantDucks';
import { useStaffTipEligibility } from '../../../hooks/useStaffTipEligibility';
import { staffTipsErrorMessage, staffTipEligibilityMessage } from '../../../services/StaffTipService';
import StaffTips from './ReportsSubItems/StaffTips/StaffTips';

export function Reports() {
  const classes = useStyles();
  const {
    selectedRestaurant,
    isLoading,
    error: restaurantError,
  } = useMenuContext();
  const dispatch = useDispatch();
  const tips = useStaffTipEligibility();

  useEffect(() => {
    const loadSettingsData = async (id) => {
      if (!id) return;
      dispatch(getSettings({ id }));
    };

    loadSettingsData(selectedRestaurant?.id);
  }, [selectedRestaurant, dispatch]);

  if (isLoading) {
    return <Loading />;
  }

  if (restaurantError) {
    return <>
      <Error />
      <Alert severity="warning" action={<Button onClick={tips.retry}>Retry restaurant information</Button>}>
        {tips.error ? staffTipsErrorMessage(tips.error) : 'Restaurant information could not be loaded.'}
      </Alert>
    </>;
  }

  if (!selectedRestaurant?.id) {
    return <NoRestaurants />;
  }

  return (
    <Box className={classes.reportsWrapper}>
      {tips.loading && <p role="status">Checking Staff Tips availability…</p>}
      {!tips.loading && !tips.configured && tips.state !== 'not_enrolled' && (
        <Alert severity="warning" action={<Button onClick={tips.retry}>Retry</Button>}>
          {tips.error ? staffTipsErrorMessage(tips.error) : staffTipEligibilityMessage(tips.state)}
          {(tips.error?.requestId || tips.error?.request_id) &&
            ` Request reference: ${tips.error.requestId || tips.error.request_id}`}
        </Alert>
      )}
      <Component
        components={[
          { label: 'Overview', component: <Overview /> },
          { label: 'Sales Tax Report', component: <SalesTaxReport /> },
          {
            label: 'Deposit Reconciliation',
            component: <DepositReconciliation />,
          },
          { label: 'POS Reconciliation', component: <POSReconciliation /> },
          { label: 'Sales Reports', component: <SalesReport /> },
          ...(tips.configured ? [{
            id: 'staff-tips',
            label: 'Staff Tips',
            component: <StaffTips key={selectedRestaurant.id} restaurantId={selectedRestaurant.id}
              timezone={tips.timezone} onConfiguredChange={tips.onConfiguredChange}
              onReportError={tips.onReportError} />,
          }] : []),
        ]}
      />
    </Box>
  );
}
